import React, { useEffect, useState } from "react";
import { BusinessHours } from "../../../interfaces/BusinessObject";
import { hasAnyHoursConfigured, isBusinessOpenNow } from "../../../services/helpers/BusinessHoursHelper";
import "./styles/BusinessLiveBadge.css";

interface BusinessLiveBadgeProps {
  hours: BusinessHours | undefined;
}

const RECHECK_INTERVAL_MS = 60_000;

const BusinessLiveBadge: React.FC<BusinessLiveBadgeProps> = ({ hours }) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), RECHECK_INTERVAL_MS);
    return () => clearInterval(id);
  }, []);

  if (!hasAnyHoursConfigured(hours)) return null;

  const open = isBusinessOpenNow(hours, now);
  return (
    <span className={`biz-live-badge ${open ? "is-open" : "is-closed"}`}>
      <span className="biz-live-badge__dot" />
      {open ? "Open now" : "Closed"}
    </span>
  );
};

export default BusinessLiveBadge;
